function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import styles from './InfiniteCarousel.module.scss';
import classNames from 'classnames';
function InfiniteCarousel(_param) {
    var children = _param.children, _param_direction = _param.direction, direction = _param_direction === void 0 ? 'right' : _param_direction, _param_speed = _param.speed, speed = _param_speed === void 0 ? 50 : _param_speed, className = _param.className, props = _object_without_properties(_param, [
        "children",
        "direction",
        "speed",
        "className"
    ]);
    var containerRef = useRef(null);
    var controls = useAnimation();
    var dir = direction === 'left' ? -1 : 1;
    useEffect(function() {
        var el = containerRef.current;
        if (el == null) return;
        var scrollWidth = el.scrollWidth / 2;
        var duration = scrollWidth / speed;
        controls.start({
            x: -dir * scrollWidth,
            transition: {
                duration: duration,
                ease: 'linear',
                repeat: Infinity
            }
        });
        return function() {
            controls.stop();
        };
    }, [
        children,
        speed,
        direction,
        controls,
        dir
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: classNames(styles.infiniteCarouselContainer, className)
    }, props), {
        children: /*#__PURE__*/ _jsxs(motion.div, {
            ref: containerRef,
            className: styles.carouselTrack,
            animate: controls,
            style: {
                display: 'flex',
                position: 'relative'
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.infiniteCarousel,
                    children: children
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.infiniteCarousel,
                    children: children
                })
            ]
        })
    }));
}
export default InfiniteCarousel;
